<ng-container [formGroup]="formGroup()" *ngIf="loaded()">
  <mat-form-field appearance="outline" [hideRequiredMarker]="hideRequiredMarker">
    <mat-label>{{ 'Kutyafajta' | translate }}</mat-label>
    <input
      type="text"
      #dogBreedInput
      matInput
      [formControlName]="formKey()"
      [matAutocomplete]="dogBreedAutoComplete"
      (focus)="filterDogBreeds()"
      (input)="filterDogBreeds()" />
    <mat-autocomplete
      requireSelection
      autoActiveFirstOption
      [displayWith]="displayFn"
      #dogBreedAutoComplete="matAutocomplete">
      @for (dogBreed of filteredDogBreeds(); track dogBreed) {
        <mat-option [value]="dogBreed.id">{{
          dogBreed[langKey] ?? '' | translate
        }}</mat-option>
      }
    </mat-autocomplete>
    <mat-error *ngIf="formGroup().controls[formKey()].hasError('required')">
      {{ 'Kutyafajta megadása kötelező!' | translate }}
    </mat-error>
  </mat-form-field>
</ng-container>
